var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 14.3333H2.83333L10.0208 7.14583L8.85417 5.97916L1.66667 13.1667V14.3333ZM13.5833 5.9375L10.0417 2.4375L11.2083 1.27083C11.5278 0.951386 11.9201 0.791664 12.3854 0.791664C12.8507 0.791664 13.2431 0.951386 13.5625 1.27083L14.7292 2.4375C15.0486 2.75694 15.2153 3.14236 15.2292 3.59375C15.2431 4.04514 15.0903 4.43055 14.7708 4.75L13.5833 5.9375ZM12.375 7.16666L3.54167 16H0V12.4583L8.83333 3.625L12.375 7.16666Z",
    fill: "#4C9AE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlueIcon);
export default __webpack_public_path__ + "static/media/edit-blue-icon.5dc5d680623d1e925f82cb8c923f22f8.svg";
export { ForwardRef as ReactComponent };